import { LeadCurd } from "./leadCrud";

export default function SaleLeads() {
  return <LeadCurd name="重要客户" type="fav" router="saleFavLeads" />;
}
